module.exports = __webpack_public_path__ + "images/_/_/shared/images/barcode_reader/barcode_d34255814a052d63100c30283b63273d.png";